var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavList',{staticClass:"main-menu__nav",attrs:{"type":_vm.isDeviceDesktop ? 'catalogDesktop' : 'catalog',"show-items":_vm.isDeviceDesktop ? 6 : 5}})
}
var staticRenderFns = []

export { render, staticRenderFns }